module.exports = __webpack_public_path__ + "img/authyicon.77fb73b9.77fb73b9.svg";